import React from 'react';
import { SECONDARY, SECONDARY_ALT } from '../../../../theme';
export var LoadingSpinner = function LoadingSpinner(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? SECONDARY_ALT : _ref$color,
      _ref$secondaryColor = _ref.secondaryColor,
      secondaryColor = _ref$secondaryColor === void 0 ? SECONDARY : _ref$secondaryColor;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ou-spinner",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("circle", {
    r: "24",
    cx: "26",
    cy: "26",
    stroke: color,
    strokeWidth: "4",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "three-quarters-circle",
    d: "M50 26C50 12.7452 39.2548 2 26 2C12.7452 2 2 12.7452 2 26C2 39.2548 12.7452 50 26 50",
    stroke: secondaryColor,
    strokeWidth: "4",
    fill: "none"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#three-quarters-circle",
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 26 26",
    to: "360 26 26",
    dur: "1.5s",
    begin: "0s",
    restart: "always",
    repeatCount: "indefinite"
  }));
};